module.exports = __webpack_public_path__ + "assets/img/timeLine_img3.525ca342.png";